import { render, staticRenderFns } from "./RiskCodeEdit.vue?vue&type=template&id=3ea00e76&scoped=true&"
import script from "./RiskCodeEdit.vue?vue&type=script&lang=js&"
export * from "./RiskCodeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea00e76",
  null
  
)

export default component.exports